import React from "react"

import InnerAndOuterLengthConfiguration from "containers/ProductDetailPage/Configurations/Cylinder/InnerAndOuterLengthConfiguration"
import SystemAndLengthCombinationConfigurations from "containers/ProductDetailPage/Configurations/Cylinder/SystemAndLengthCombinationConfigurations"
import LockingMechanismConfiguration from "containers/ProductDetailPage/Configurations/Cylinder/LockingMechanismConfiguration"
import SystemAndOuterLengthConfiguration from "containers/ProductDetailPage/Configurations/Cylinder/SystemAndOuterLengthConfiguration"
import OuterLengthConfiguration from "containers/ProductDetailPage/Configurations/Cylinder/OuterLengthConfiguration"
import SystemConfiguration from "containers/ProductDetailPage/Configurations/Cylinder/SystemConfiguration"

import {
	ProductDetailPageReducerState,
	DispatchProductDetailPageReducer,
} from "@secureo/common/reducers/productDetailPageReducer"

// Temp fix for https://github.com/yannickcr/eslint-plugin-react/issues/2654
// Please remove at later point in time
/* eslint-disable react/prop-types */
const MainCylinderConfiguration = ({ accessToken, dispatch, reducerState }: Props) => {
	const {
		isLoading,
		attributes: {
			innerLengthsByOuterLengths,
			lengthCombinationsBySystem,
			outerLengthsBySystem,
			outerLengths,
			systems,
		},
	} = reducerState

	if (innerLengthsByOuterLengths)
		return (
			<InnerAndOuterLengthConfiguration
				isLoading={isLoading}
				dispatch={dispatch}
				reducerState={reducerState}
				accessToken={accessToken}
			/>
		)

	if (lengthCombinationsBySystem)
		return (
			<SystemAndLengthCombinationConfigurations
				isLoading={isLoading}
				dispatch={dispatch}
				reducerState={reducerState}
				accessToken={accessToken}
			/>
		)

	if (outerLengthsBySystem)
		return (
			<SystemAndOuterLengthConfiguration
				isLoading={isLoading}
				dispatch={dispatch}
				reducerState={reducerState}
				accessToken={accessToken}
			/>
		)

	if (outerLengths)
		return (
			<OuterLengthConfiguration
				isLoading={isLoading}
				dispatch={dispatch}
				reducerState={reducerState}
				accessToken={accessToken}
			/>
		)

	if (systems)
		return (
			<SystemConfiguration
				isLoading={isLoading}
				dispatch={dispatch}
				reducerState={reducerState}
				accessToken={accessToken}
			/>
		)

	return null
}

const CylinderConfigurations = ({ accessToken, reducerState, dispatch }: Props) => {
	const { isLoading, taxRate, cylinderLockingMechanismProducts } = reducerState

	return (
		<>
			<MainCylinderConfiguration
				accessToken={accessToken}
				reducerState={reducerState}
				dispatch={dispatch}
			/>

			{cylinderLockingMechanismProducts && (
				<LockingMechanismConfiguration
					isLoading={isLoading}
					dispatch={dispatch}
					reducerState={reducerState}
					taxRate={taxRate}
				/>
			)}
		</>
	)
}

interface Props {
	accessToken: string
	dispatch: DispatchProductDetailPageReducer
	reducerState: ProductDetailPageReducerState
}

export default CylinderConfigurations
